<div class="row form" *ngIf="book != null">
  <app-loading-modal></app-loading-modal>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-4">
          <h4 class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>Detalle reserva</h4>
        </div>
        <div class="col-sm-8 form__head__boxBtn">
          <button type="button" class="btn btn-secondary btn-sm hide-xs" (click)="cancel()"><i
              class="fas fa-arrow-left m-r-5"></i> Regresar
          </button>
          <a type="button" class="btn btn-danger btn-sm text-white" (click)="checkOut()"
            *ngIf="book.is_checkin == true && book.is_checkout == false">
            <i class="fas fa-arrow-down m-r-2"></i> ANULAR
          </a>
          <a type="button" class="btn btn-primary btn-sm text-white" (click)="checkIn()"
            *ngIf="book.is_checkin == false">
            <i class="fas fa-check m-r-2"></i> CHECK-IN
          </a>
          <a type="button" class="btn btn-info text-white btn-sm" (click)="recover()"
            *ngIf="book.is_checkin == true && book.is_checkout == true">
            <i class="fas fa-undo m-r-2"></i> Recuperar
          </a>
          <button type="button" class="btn btn-info btn-sm" (click)="bookingCommision(book)" data-toggle="modal"
            data-target="#openExtendsBookingsCommission">
            <i class="fas fa-minus-circle m-r-3"></i> Comisionar
          </button>
          <button type="button" class="btn btn-success btn-sm" (click)="bookingAmortization(book)"
            *ngIf="book.total != book.total_paid" data-toggle="modal" data-target="#openExtendsBookingsAmortization">
            <i class="fas fa-money-bill-alt m-r-3"></i>Amortizar
            {{toolsService.momeySol()}}{{(book.total - book.total_paid).toFixed(2)}}
          </button>
          <!-- <button type="button" class="btn btn-light btn-sm" (click)="printer()">
            <i class="fas fa-print m-r-3"></i>
          </button> -->
          <a type="button" class="btn btn-light btn-sm" target="_blank"
            href="/{{branchofficeSlug}}/api/bookings/export/file/pdf/{{book.id}}">
            <i class="far fa-file-pdf m-r-3 text-danger"></i> Ficha
          </a>
          <button class="btn btn-sm btn-primary" *ngIf="book.is_checkout == false" (click)="edit(book.id)"><i
              class="fas fa-pen-alt m-r-2"></i>Editar
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-50" id="body">
      <div class="card-body faq-box boder-left-{{book.status_booking.class}}">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__background">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail position-relative">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Estado</div>
                <div class="child-right">
                  <span class="badge f-s-12 badge-{{book.status_booking.class}}">{{book.status_booking.message}}</span>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Código reserva</div>
                <div class="child-right">
                  <span class="bold">{{book.code}}
                    <i *ngIf="book.is_favorite" class="fas fa-star m-l-2 color-favorite"></i>
                  </span>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left bold">Responsable</div>
                <div class="child-right">
                  {{book.client_data.fullname}}
                  <p class="bold f-s-10 m-b-0">{{book.client_data.typeDocument}} :
                    {{book.client_data.document}}</p>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">N° PAX</div>
                <div class="child-right">
                  {{book.nro_pax}} (personas)
                  <div class="d-inline-block m-l-5" *ngIf="book.is_reference_pax">
                    REF:
                    <span>Niños ({{book.nro_pax_childs}})</span>,
                    <span>Adultos({{book.nro_pax_adults}})</span>,
                    <span>Ancianos ({{book.nro_pax_olds}})</span>
                  </div>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Teléfonos</div>
                <div class="child-right">
                  {{book.client_data.cellphone}}
                  <span class="m-l-5" ng-if="book.client_data.telephone != null">
                    - {{book.client_data.telephone}}
                  </span>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Fecha de llegada</div>
                <div class="child-right">
                  {{book.date_arrival | date: 'mediumDate'}}
                  <span class="bold f-s-10 m-b-0 m-l-3">Hora : {{book.time_arrival}}</span>
                  <ng-container *ngIf="book.date_departure != null">
                    <span class="m-l-10 f-s-11">- Salida ({{book.date_departure | date: 'mediumDate'}})</span>
                  </ng-container>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Referencia llegada</div>
                <div class="child-right">
                  {{book.arrivalplace_data.description}}
                  <span class="m-l-5">(<span>{{book.arrival_place}}</span>)</span>
                </div>
              </div>
              <ng-container *ngIf="book.employee_id != null">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                  <div class="child-left">Asesor(a)</div>
                  <div class="child-right">
                    {{book.employee_data.fullname}}
                    <p class="bold f-s-10 m-b-0">DOC:{{book.employee_data.document}}</p>
                  </div>
                </div>
              </ng-container>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">N° ref. ó etiqueta
                  <span *ngIf="book.workinggroup_id != null">/ Grupo</span>
                </div>
                <div class="child-right">
                  {{book.reference_voucher}}
                  <ng-container *ngIf="book.workinggroup_id != null">
                    / <span class="badge badge-dark m-l-5 f-s-9">{{book.workinggroup_data.description}}</span>
                  </ng-container>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row" *ngIf="book.is_book_hotel">
                <div class="child-left"><i class="fas fa-hotel"></i></div>
                <div class="child-right">
                  <span class="badge badge-hotel">RESERVA SOLO HOTEL</span>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">R.Usuario</div>
                <div class="child-right">
                  <span class="text-uppercase">{{book.user_data.username}} </span>
                  <ng-container *ngIf="book.user_updated_id != null">
                    <span class="m-l-10 f-s-10">(última actualización usuario: {{book.user_updated_data.username}}
                      {{book.updated_at | date: 'short'}} )</span>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12" *ngIf="!book.is_book_hotel">
          <p class="form__group__title m-b-0 f-s-12"><i class="fas fa-map-marker-alt m-r-5"></i>Datos de tours
          </p>
          <div class="table-responsive">
            <table class="table table-sm mb-0">
              <thead class="thead-default">
                <tr>
                  <th>Nombre tours</th>
                  <th class="text-center">N° PAX</th>
                  <th>Vehículo</th>
                  <th>Turno</th>
                  <th>F. asignada</th>
                  <th>Estado</th>
                  <th>F. realizada</th>
                  <th>Obs.</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="tours.length == 0">
                  <tr>
                    <td colspan="6"><span>No se encontraron registros</span></td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="tours.length > 0">
                  <tr *ngFor="let item of tours; let index_ = index" [ngClass]="{'text-open': item.is_open}">
                    <td>
                      {{item.description}}
                      <span *ngIf="item.is_open" class="m-l-5">(Estado abierto)</span>
                      <p class="f-s-10" *ngIf="item.is_transfer == true">
                        <span class="bold">TRASPASADO: ({{item.agency_operator.tradename}}) </span>
                      </p>
                    </td>
                    <td class="text-center">{{item.quantity}}</td>
                    <td>
                      <span
                        class="badge f-s-10 badge-{{item.vehicle_tour_content.class}}">{{item.vehicle_tour_content.description}}</span>
                    </td>
                    <td><span class="bold">{{item.shift_tour_content.description}}</span></td>
                    <td>{{item.date_assigned | date: 'mediumDate'}}
                    <td *ngIf="item.group_assigned != null">
                      <span class="badge badge-pink">Asignado</span>
                      <p (click)="groupDetailExtends(item.group_assigned.group_id)" data-toggle="modal"
                        data-target="#openGroupDetailExtends" class="bold pointer grid__link d-inline f-s-10">
                        {{item.group_assigned.group.code}}</p>
                    </td>
                    <td *ngIf="item.group_assigned == null">
                      <span class="badge badge-success f-s-10" *ngIf="item.status_realized == true">Confirmado</span>
                      <span class="badge badge-warning f-s-10" *ngIf="item.status_realized == false">Pendiente</span>
                    </td>
                    <td>
                      <span *ngIf="item.is_transfer == false">
                        {{item.date_realized | date: 'mediumDate'}}
                      </span>
                    </td>
                    <td class="text-center">{{item.observation}}</td>
                    <td>
                      <ng-container *ngIf="!item.is_realized">
                        <button class="btn btn-sm f-s-9 btn-secondary bold" style="padding: 3px 5px"
                          (click)="extendsTransfers(book, item)" data-toggle="modal"
                          data-target="#openExtendsTransfers">Traspasar <i
                            class="fas fa-angle-double-right m-l-2"></i></button>
                      </ng-container>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
          <div class="m-t-10">
            <label class="f-s-11">Ubicación y referencias de ubicación
              <i class="fas fa-info-circle m-l-5" data-toggle="tooltip" data-placement="right"
                data-original-title="Información de hotel, dirección, para el recojo de los tours del pasajero."></i></label>
            <span *ngIf="book.reference_location == null">Sin especificar</span>
            <textarea *ngIf="book.reference_location != null" disabled rows="2"
              class="form-control form-control-sm no-resize f-s-11 select-read">{{book.reference_location}}</textarea>
          </div>
        </div>
        <div class="col-12 m-t-15">
          <p class="form__group__title m-b-0 f-s-12"><i class="fas fa-bed m-r-5"></i>Datos reservas de alojamiento</p>
          <div class="table-responsive">
            <table class="table table-sm mb-0">
              <thead class="thead-default">
                <tr>
                  <th>Código</th>
                  <th>Nombre Hotel</th>
                  <th>Detalle Hab.</th>
                  <th>Deuda</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="hotels.length == 0">
                  <tr>
                    <td colspan="6">No se registran datos</td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="hotels.length > 0">
                  <tr *ngFor="let item of hotels; let index_ = index">
                    <td><span class="bold text-primary">{{item.code}}</span></td>
                    <td>
                      <span class="bold">{{item.tradename}}</span> ({{item.citietouristic}})
                      <p class="m-b-0 f-s-10">Cel: {{item.cellphone}}</p>
                    </td>
                    <td>
                      <div *ngFor="let bedroom of item.detail_bedrooms">
                        <p class="m-b-0">{{bedroom.typebedroom}} <span class="f-s-11"> ({{bedroom.quantity}}
                            hab. x {{bedroom.nights}} noches) </span></p>
                        <span class="f-s-9 d-block m-b-5" style="font-weight: 600;"><i
                            class="far fa-calendar-alt m-r-2"></i> {{bedroom.date_checkin}} -
                          {{bedroom.date_checkout}}
                          <span class="badge badge-success f-s-8 bold m-l-5" *ngIf="bedroom.is_paid">
                            Reporte cuadre
                          </span>
                        </span>
                      </div>
                    </td>
                    <td>
                      <span class="text-danger">{{item.total | currency:'S/'}}</span>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>

        <div class="col-12 m-t-15 hide" style="display: none;">
          <p class="form__group__title m-b-0 f-s-12"><i class="fas fa-plane-departure m-r-5"></i>Datos de
            vuelo</p>
          <div class="m-t-10">
            <span ng-if="book.register_flight == null">Sin especificar</span>
            <textarea ng-if="book.register_flight != null" ng-disabled="true" rows="2"
              class="form-control form-control-sm no-resize f-s-11 select-read"
              ng-model="book.register_flight"></textarea>
          </div>
        </div>
        <div class="col-12 m-t-20">
          <p class="form__group__title m-b-0 f-s-12"><i class="fas fa-info-circle m-r-5"></i>RESUMEN TOTAL
            S/</p>
          <div class="table-responsive">
            <table class="table table-sm mb-0">
              <thead class="thead-default">
                <tr>
                  <!-- <th>TOTAL TOURS</th>
                  <th>TOTAL HOTEL</th>-->
                  <th>SUBTOTAL VUELO</th>
                  <th class="text-center">
                    <span class="text-primary">TOTAL PAQUETE</span>
                  </th>
                  <th class="text-center">
                    <span class="text-success">PAGADO</span>
                  </th>
                  <th class="text-right">
                    <span class="text-danger">SALDO PENDIENTE</span>
                  </th>
                  <th class="text-right">
                    <span class="text-info">FACTURADO</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <!-- <td>{{book.subtotal_tour | currency:'S/.'}}</td>
                  <td>{{book.subtotal_hotel | currency:'S/.'}}</td>-->
                  <td>{{book.subtotal_flight | currency:'S/.'}}</td>
                  <td class="text-center">
                    <span class="text-primary bold">{{toolsService.momeySol()}}{{book.total}}</span>
                  </td>
                  <td class="text-center">
                    <span class="text-success bold">{{toolsService.momeySol()}}{{book.total_paid}}</span>
                  </td>
                  <td class="text-right">
                    <span
                      class="text-danger bold">{{toolsService.momeySol()}}{{(book.total - book.total_paid).toFixed(2)}}</span>
                  </td>
                  <td class="text-right">
                    <span class="text-info bold">{{toolsService.momeySol()}}{{book.total_billing}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-12 m-t-20">
          <p class="form__group__title m-b-0 f-s-12"><i class="fas fa-money-bill-alt m-r-5"></i>Comprobantes y
            cobros realizados</p>
          <div class="table-responsive">
            <table class="table table-sm mb-0">
              <thead class="thead-default">
                <tr>
                  <th>R.Usuario</th>
                  <th>Tipo comprobante</th>
                  <th>N° comprobante</th>
                  <th>Fecha</th>
                  <th class="w-15 text-center">Método pago</th>
                  <th class="w-15 text-right">Pagado</th>
                  <th class="w-15 text-center">Comprobante</th>
                  <th class="w-15 text-center">constancia</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="movements.length == 0">
                  <tr>
                    <td colspan="7">No registra datos de cobros.</td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="movements.length > 0">
                  <tr *ngFor="let item of movements; let index_ = index" [ngClass]="{'text-danger': item.date_repayment != null}">
                    <td>{{item.user_data.username}}</td>
                    <td>{{item.typevoucher}}</td>
                    <td>{{item.nro_voucher}}</td>
                    <td>{{item.date_movement  |  date: 'YYYY-MM-dd'}}</td>
                    <td class="w-15 text-center">{{item.paymethod.description}}</td>
                    <td class="w-15 text-right">{{toolsService.momeySol()}}{{item.total_amount}}</td>
                    <td class="w-15 text-center">
                      <div *ngIf="item.date_repayment == null">
                        <ng-container *ngIf="item.booking_id == null">
                          <a title="{{item.typevoucher}}" class="text-warning pointer bold" target="_blank"
                          href="/{{branchofficeSlug}}/api/print/billing/document/{{item.id}}"
                          *ngIf="item.voucher_id == typevoucher_factura.id || item.voucher_id == typevoucher_boleta.id || item.voucher_id == typevoucher_ordernote.id">
                          <i class="fas fa-print f-s-16"></i>
                        </a>
                        </ng-container>
                        <ng-container *ngIf="item.booking_id != null">
                          <a title="{{item.typevoucher}}" class="text-warning pointer bold" target="_blank"
                            href="/{{branchofficeSlug}}/api/print/billing/document/booking/{{item.id}}"
                            *ngIf="item.voucher_id == typevoucher_factura.id || item.voucher_id == typevoucher_boleta.id || item.voucher_id == typevoucher_ordernote.id">
                            <i class="fas fa-print f-s-16"></i>
                          </a>
                        </ng-container>
                        <a title="{{item.typevoucher}}" class="text-warning pointer bold" target="_blank"
                          href="/{{branchofficeSlug}}/api/print/income/document/{{item.id}}"
                          *ngIf="item.voucher_id == typevoucher_income.id || item.voucher_id == typevoucher_expense.id">
                          <i class="fas fa-print f-s-16"></i>
                        </a>
                      </div>
                      <div *ngIf="item.date_repayment != null">
                        <span class="badge badge-danger f-s-10">Comprobante de baja</span>
                      </div>
                    </td>
                    <td class="text-center">
                      <span *ngIf="item.url_image != null">
                        <a class="text-info pointer bold" href="tenants/{{item.url_image}}" download>
                          <i class="fas fa-file-download f-s-16"></i>
                        </a>
                      </span>
                      <!-- <span *ngIf="item.url_image == null">
                        <a class="text-dark pointer" title="Subir constancia" data-toggle="modal" 
                          data-target="#openExtendsUploadFileMovement" (click)="UploadFileMovementsExtendsComponent.init(item)">
                          <i class="fas fa-upload f-s-16"></i>
                        </a>
                      </span> -->
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-12 m-t-20">
          <p class="form__group__title m-b-0 f-s-12"><i class="fas fa-users m-r-5"></i>Comisiones</p>
          <div class="table-responsive">
            <table class="table table-sm mb-0">
              <thead class="thead-default">
                <tr>
                  <th>Nombre mototaxista</th>
                  <th>Empresa</th>
                  <th>Celular</th>
                  <th>Fecha</th>
                  <!-- <th class="text-center">COMISIÓN HOTEL</th>
                  <th class="text-center">COMISIÓN TOURS</th> -->
                  <th class="text-center">TOTAL COMISIÓN</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="commissions.length == 0">
                  <tr>
                    <td colspan="7">No registra datos de cobros.</td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="commissions.length > 0">
                  <tr *ngFor="let item of commissions; let index_ = index">
                    <td>
                      {{item.collaborator_data.fullname}}
                      <p class="bold f-s-10 m-b-0">Doc : {{item.collaborator_data.document}}</p>
                    </td>
                    <td>{{item.collaborator_data.partnercompany}}</td>
                    <td>{{item.collaborator_data.cellphone}}</td>
                    <td>{{item.date_commision}}</td>
                    <!-- <td class="text-center">
                      <ng-container *ngIf="item.total_hotel != null">
                        {{toolsService.momeySol()}}{{item.total_hotel}}
                      </ng-container>
                    </td>
                    <td class="text-center">
                      <ng-container *ngIf="item.total_hotel != null">
                        {{toolsService.momeySol()}}{{item.total_tour}}
                      </ng-container>
                    </td> -->
                    <td class="text-center">{{toolsService.momeySol()}}{{item.total_commission}}</td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-12 m-t-20">
          <button type="button" class="btn btn-light waves-effect waves-light" (click)="getAuditing()">
            Registro Auditoría <i class="far fa-clock m-l-5"></i>
          </button>
        </div>
        <!-- <ng-container *ngIf="filteredAuditsBooking.length > 0">
          <div class="col-12 m-t-20">
            <button type="button" class="btn btn-light waves-effect waves-light" data-toggle="modal"
              data-target="#myModal">
              Registro Auditoría <i class="far fa-clock m-l-5"></i>
            </button>

          </div>
        </ng-container> -->
      </div>
    </div>
  </div>
  <!-- sample modal content -->
  <div id="modalAuditing" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title mt-0">Registro auditoría cambios | Reserva <span class="bold">{{book.code}}</span></h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="max-height: 500px;overflow-y: auto;">
          <div class="table-responsive">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th>Fecha y Hora</th>
                  <th>Usuario</th>
                  <th>Evento</th>
                  <th>Alias</th>
                  <th class="text-center">Detalles</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let audit of filteredAuditsBooking; let i = index">
                  <tr>
                    <td>{{ audit.created_at | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                    <td>{{ audit.user || 'Desconocido' }}</td>
                    <td>{{ audit.event }}</td>
                    <td>
                      {{ audit.alias }}
                      <ng-container *ngIf="audit.model === 'ToursBooking'">
                        <p class="m-t-2 m-b-0 f-s-10"><span class="bold">Item</span>:{{ audit.tour_name }}</p>
                      </ng-container>
                    </td>
                    <!-- <td>{{ audit.device_name }}</td> -->
                    <td class="text-center">
                      <button class="btn btn-sm f-s-10" [ngClass]="expandedIndex === i ? 'btn-dark' : 'btn-info'"
                        (click)="toggleDetails(i, audit)">
                        {{ expandedIndex === i ? 'Ocultar' : 'Ver detalles' }}
                        <ng-container *ngIf="expandedIndex === i">
                          <i class="fas fa-arrow-up"></i>
                        </ng-container>
                        <ng-container *ngIf="expandedIndex !== i">
                          <i class="fas fa-arrow-down"></i>
                        </ng-container>
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="expandedIndex === i">
                    <td colspan="6" style="padding: 0px !important;">
                      <div class="card m-b-5" style="background: #fffbfb;">
                        <div class="card-body p-l-10 p-r-10 p-t-5 p-b-5">
                          <h5 class="m-t-10 f-s-15 text-underline">Detalles de la Auditoría</h5>
                          <ul>
                            <li><strong>Usuario:</strong> {{ selectedAudit?.user }}</li>
                            <li><strong>Acción:</strong> {{ selectedAudit?.event }}</li>
                            <li><strong>Fecha:</strong> {{ selectedAudit?.created_at | date: 'dd/MM/yyyy HH:mm:ss' }}
                            </li>
                            <ng-container *ngIf="selectedAudit?.model === 'ToursBooking'">
                              <li><strong>Item:</strong> {{ selectedAudit?.tour_name }}</li>
                            </ng-container>
                          </ul>
                          <h6 style="color: red;">Valores Anteriores</h6>
                          <ul>
                            <li *ngFor="let key of objectKeys(selectedAudit?.old_values)">
                              <strong>{{ key }}:</strong> {{ selectedAudit?.old_values[key] }}
                            </li>
                          </ul>
                          <h6 style="color: green;">Valores Nuevos</h6>
                          <ul>
                            <li *ngFor="let key of objectKeys(selectedAudit?.new_values)">
                              <strong>{{ key }}:</strong> {{ selectedAudit?.new_values[key] }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary waves-effect" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</div>


<app-bookings-amortization-extends (onSubmitEvent)="beforeAmortization($event)"></app-bookings-amortization-extends>
<app-bookings-commission-extends (onSubmitEvent)="beforeAmortization($event)"></app-bookings-commission-extends>
<app-transfers-extends (onSubmitEvent)="afterTransfer($event)"></app-transfers-extends>
<app-group-detail-extends></app-group-detail-extends>
<app-upload-file-movements-extends></app-upload-file-movements-extends>
